import type { OrganizationDetail } from "../../account";

type OrganizationServicesStepProps = {
  application: Record<string, unknown> | null;
  data: OrganizationDetail;
};

export function OrganizationServicesStep({
  application,
  data,
}: OrganizationServicesStepProps) {
  return (
          <fieldset className="wide-field">
            <legend>3. Palvelut ja laskutusyhteys</legend>
            <div className="application-service-grid">
              <label>
                <input
                  type="checkbox"
                  name="requestedServices"
                  value="area_management"
                />{" "}
                Hallinnoi alueita
              </label>
              <label>
                <input
                  type="checkbox"
                  name="requestedServices"
                  value="permit_issuing"
                />{" "}
                Myönnä lupia
              </label>
              <label>
                <input
                  type="checkbox"
                  name="requestedServices"
                  value="permit_sales"
                />{" "}
                Myy lupia
              </label>
              <label>
                <input
                  type="checkbox"
                  name="requestedServices"
                  value="payment_receiving"
                />{" "}
                Vastaanota maksuja
              </label>
              <label>
                <input
                  type="checkbox"
                  name="requestedServices"
                  value="financial_reporting"
                />{" "}
                Talousraportit
              </label>
            </div>
            <div className="application-field-grid">
              <label>
                Palvelupaketti
                <select
                  name="servicePlanId"
                  required
                  defaultValue={String(application?.service_plan_id ?? "")}
                >
                  <option value="" disabled>
                    Valitse paketti
                  </option>
                  {data.servicePlans.map((plan) => (
                    <option value={String(plan.id)} key={String(plan.id)}>
                      {String(plan.name)} ·{" "}
                      {plan.unit_amount === null
                        ? "sopimushinta"
                        : (Number(plan.unit_amount) / 100).toLocaleString(
                            "fi-FI",
                            {
                              style: "currency",
                              currency: String(plan.currency),
                            },
                          ) +
                          (plan.billing_interval === "month"
                            ? "/kk"
                            : "/vuosi")}
                    </option>
                  ))}
                </select>
              </label>
              <label>
                Laskutusyhteyshenkilö
                <input
                  name="billingContactName"
                  minLength={2}
                  maxLength={200}
                  required
                />
              </label>
              <label>
                Laskutussähköposti
                <input
                  name="billingContactEmail"
                  type="email"
                  required
                  defaultValue={data.organization.contact_email ?? ""}
                />
              </label>
            </div>
          </fieldset>
  );
}

